import React from 'react';
import classnames from 'classnames';

import './index.css';

export const Form = ({className, ...rest}) => <form {...rest} className={classnames('form', className)} />;
